import { collection, doc, setDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import React from 'react';
import toast from 'react-hot-toast';
import { useTheme } from 'styled-components';

import { useGlobalModalContext } from '../../../../../context/GlobalModal';
import { useForm } from '../../../../../hooks';
import { functions, firestore, STORAGE_URL } from '../../../../../services/Firebase';
import { Button, Input, Modal, SelectForm, Splash } from '../../../../../shared/Components';
import { GridContainer } from '../../../../../shared/Typhography';
import { strings } from '../../../../../strings';
import { RoleValue } from '../../../../../types';
import { CreateAdminField, createAdminSchema } from '../../../../../validations/createAdmin';

interface CreateAdminInputs {
  [CreateAdminField.NAME]: string;
  [CreateAdminField.EMAIL]: string;
  [CreateAdminField.USERNAME]: string;
  [CreateAdminField.PASSWORD]: string;
  [CreateAdminField.CONFIRM_PASSWORD]: string;
  [CreateAdminField.ROLE]: { value: string; label: string };
}

const AddMemberModal = () => {
  const { colors } = useTheme();
  const [loading, setLoading] = React.useState<boolean>(false);
  const { hideModal } = useGlobalModalContext();
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<CreateAdminInputs>({
    schema: createAdminSchema,
  });
  const roles = [
    { value: RoleValue.ADMIN, label: strings.admin },
    { value: RoleValue.GOTIVA_MEMBER, label: strings.gotivaMember },
  ];

  const add = handleSubmit(async (data: CreateAdminInputs) => {
    setLoading(true);
    try {
      const usersRef = collection(firestore, 'usersWeb');

      const createuser = httpsCallable(functions, 'createUser');

      const member: any = (await createuser({ email: data.email, password: data.password })).data;

      await setDoc(doc(usersRef, member), {
        Name: data.name,
        Role: data.role.value,
        profileImageUrl: `${STORAGE_URL}/profilephotos/gotivaprofile.png`,
        username: data.username,
        email: data.email,
      });
      hideModal();
      toast.success(`${strings.successfullyAddedNew} ${data.role.value}`);
      reset();
      setLoading(false);
    } catch (error) {
      if (error == 'FirebaseError: INTERNAL') {
        toast.error(strings.emailTaken);
      } else {
        toast.error(strings.somethingWentWrong);
      }
      setLoading(false);
    }
  });

  return (
    <Modal padding="30px" width={700} onRequestClose={hideModal}>
      <GridContainer cols={2} gap="1rem">
        <Input
          required
          type="text"
          name={CreateAdminField.NAME}
          control={control}
          error={errors[CreateAdminField.NAME]}
          placeholder={CreateAdminField.NAME}
          width="300px"
        />
        <Input
          required
          type="text"
          name={CreateAdminField.EMAIL}
          control={control}
          error={errors[CreateAdminField.EMAIL]}
          placeholder={CreateAdminField.EMAIL}
          width="300px"
        />
        <Input
          required
          type="password"
          name={CreateAdminField.PASSWORD}
          control={control}
          error={errors[CreateAdminField.PASSWORD]}
          placeholder={CreateAdminField.PASSWORD}
          width="300px"
        />
        <Input
          required
          type="text"
          name={CreateAdminField.USERNAME}
          control={control}
          error={errors[CreateAdminField.USERNAME]}
          placeholder={CreateAdminField.USERNAME}
          width="300px"
        />
        <Input
          required
          type="password"
          name={CreateAdminField.CONFIRM_PASSWORD}
          control={control}
          error={errors[CreateAdminField.CONFIRM_PASSWORD]}
          placeholder={CreateAdminField.CONFIRM_PASSWORD}
          width="300px"
        />
        <div>
          <SelectForm
            required
            width="300px"
            name={CreateAdminField.ROLE}
            placeholder={CreateAdminField.ROLE}
            control={control}
            values={roles}
            error={errors[CreateAdminField.ROLE]}
          />
        </div>
        <Button width={300} height={50} onClick={add}>
          {loading ? <Splash color={colors.white} width={25} height={25} /> : strings.submit}
        </Button>
      </GridContainer>
    </Modal>
  );
};

export default AddMemberModal;
